import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../utils';

export const AdditionalDocsApi = createAsyncThunk(
  'AdditionalDocsApi',
  async (additionalDocsPayload, { dispatch }) => {
    dispatch({ type: 'AdditionalDocsApi/pending', payload: {} });

    const { customerId, Authorization, customerRefNum, journeyType } =
      additionalDocsPayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'customerJourney/additionaldocuments',
      payload: {
        customerRefNum,
        journeyType,
        appId: APP_ID,
        appVersion: APP_VERSION,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const additionalDocsRes = res;
        dispatch({
          type: 'AdditionalDocsApi/fulfilled',
          payload: additionalDocsRes,
        });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'AdditionalDocsApi/rejected', payload: err });
      },
    });
  }
);

export const AdditionalDocsApi_extrareducer = {
  [AdditionalDocsApi.pending]: (state, action) => {
    state.additionalDocsApiState.isLoading = true;
  },
  [AdditionalDocsApi.fulfilled]: (state, action) => {
    state.additionalDocsApiState.isLoading = false;
    state.additionalDocsApiState.isSuccess = true;
    state.additionalDocsApiState.isError = false;
    state.additionalDocsApiState.response = action.payload;
  },
  [AdditionalDocsApi.rejected]: (state, action) => {
    state.additionalDocsApiState.isLoading = false;
    state.additionalDocsApiState.isSuccess = false;
    state.additionalDocsApiState.isError = true;
    state.additionalDocsApiState.response = action.payload;
  },
};
